import {
    heartbeat,
    HEARTBEAT_INTERVAL_MS,
    HEARTBEAT_MAX_RETRIES,
    HeartbeatActionTypes,
    redirectToLogin
} from "../heartbeat"
import {combineEpics, ofType} from 'redux-observable';
import 'rxjs/Rx'
import {map, mergeMap} from 'rxjs/operators'
import {concat, from, interval, of} from 'rxjs'

export const ActionTypes = {
    OnEnter: "CommonUI_OnEnter",
    OnRedirectToLogin: "CommonUI_OnRedirectToLogin",
    OnHeartbeatStarted: "CommonUI_OnHeartbeatStarted",
    OnHeartbeatRetry: "CommonUI_OnHeartbeatRetry",
};

const initialState = {
    heartbeatErrors: 0
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.OnEnter:
            return state;

        case ActionTypes.OnRedirectToLogin:
            // TODO: A better way to handle the situation, where the heartbeat is constantly failing,
            // could be just showing an message like "There seems to be a connection problem".
            // User might be in the middle of something that she would lose, when redirecting to login.
            // And in case the connection is restored they could resume where they had left.
            redirectToLogin();
            return state;

        case HeartbeatActionTypes.OnHeartbeat:
            console.log("Heartbeat:", action.heartbeat);
            const {username, roles, supplierId, supplierPortalIds, carrierId, contextType} = action.heartbeat;
            return {
                ...state,
                heartbeatErrors: 0,
                user: {username, contextType, roles, supplierIds: supplierId, supplierPortalIds, carrierId}
            };

        case HeartbeatActionTypes.OnHeartbeatError:
            const {heartbeatErrors} = state;
            return {...state, heartbeatErrors: heartbeatErrors + 1};
    }
    return state;
};

const enter = (action$) => action$.pipe(
    ofType(ActionTypes.OnEnter),
    map(action => {
        return {type: ActionTypes.OnHeartbeatStarted};
    })
);

const startHeartbeat = (action$, state$) => action$.pipe(
    ofType(ActionTypes.OnHeartbeatStarted),
    mergeMap(action => {
        // First heartbeat, and then then periodically invoke heartbeat
        return concat(
            of({type: HeartbeatActionTypes.Invoke, retries: 0}),
            interval(HEARTBEAT_INTERVAL_MS).pipe(
                map(() => {
                    const state = state$.value;
                    console.log("State", state);
                    const {app: {heartbeatErrors}} = state;
                    return {type: HeartbeatActionTypes.Invoke, retries: heartbeatErrors};
                })
            )
        )
    })
);

const invokeHeartbeat = (action$) => action$.pipe(
    ofType(HeartbeatActionTypes.Invoke),
    mergeMap(action => {
        console.log("Heartbeat", action);
        const result = heartbeat().then(response => {
            if (!response.ok) {
                const {retries} = action;
                if (retries >= HEARTBEAT_MAX_RETRIES) {
                    return {
                        type: HeartbeatActionTypes.OnHeartbeatMaxErrors,
                        error: response.statusText,
                        retries
                    };
                } else {
                    return {
                        type: HeartbeatActionTypes.OnHeartbeatError,
                        error: response.statusText,
                        retries
                    };
                }
            } else {
                return response.json().then(result => {
                    return {type: HeartbeatActionTypes.OnHeartbeat, heartbeat: result};
                });
            }
        });
        return from(result);
    })
);

const heartbeatError = (action$) => action$.pipe(
    ofType(HeartbeatActionTypes.OnHeartbeatError),
    map(action => {
        console.warn("Heartbeat failed:", action.error, "; retrying (" + action.retries + ")");
        return {type: ActionTypes.OnHeartbeatRetry};
    })
);

const heartbeatRedirect = (action$) => action$.pipe(
    ofType(HeartbeatActionTypes.OnHeartbeatMaxErrors),
    map(action => {
        console.error("Heartbeat failed:", action.error, "; redirecting to login (" + action.retries + ")");
        return {type: ActionTypes.OnRedirectToLogin};
    })
);

export default {
    reducer: reducer,
    epic: combineEpics(enter, startHeartbeat, invokeHeartbeat, heartbeatError, heartbeatRedirect)
}
